// `requiredIf.unlessAllOf` lists the platform overrides that can stand in for a
// shared image: the shared field stays required until every one of them is set.
// It is not simply "always required" because shared used to be disabled while an
// override existed, so templates built before the base-layer model have platform
// images and no shared image, and must remain valid to edit.
export const IMAGE_CONFIG = {
  loyalty: {
    shared: {
      logo: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.logo', 'google.logo'] },
        affects: ['apple.logo', 'google.logo', 'shared.icon', 'apple.icon'],
      },
      icon: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.icon', 'google.logo'] },
        affects: ['apple.icon', 'google.logo', 'shared.logo', 'apple.logo'],
      },
      banner: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.banner', 'google.banner'] },
        affects: ['apple.banner', 'google.banner'],
      },
    },

    apple: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'google.logo', 'shared.icon'],
      },
      icon: {
        visible: true,
        affects: ['shared.icon', 'google.logo', 'shared.logo'],
      },
      banner: {
        visible: true,
        affects: ['shared.banner', 'google.banner'],
      },
    },

    google: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'shared.icon', 'apple.logo', 'apple.icon'],
      },
      wideLogo: { visible: true },
      banner: {
        visible: true,
        affects: ['shared.banner', 'apple.banner'],
      },
    },
  },
  generic: {
    shared: {
      logo: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.logo', 'google.logo'] },
        affects: ['apple.logo', 'google.logo', 'shared.icon', 'apple.icon'],
      },
      icon: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.icon', 'google.logo'] },
        affects: ['apple.icon', 'google.logo', 'shared.logo', 'apple.logo'],
      },
    },
    apple: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'google.logo', 'shared.icon'],
      },
      icon: {
        visible: true,
        affects: ['shared.icon', 'google.logo', 'shared.logo'],
      },
      thumbnail: { visible: true },
    },
    google: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'shared.icon', 'apple.logo', 'apple.icon'],
      },
      wideLogo: { visible: true },
      banner: { visible: true },
    },
  },
  eventTicket: {
    shared: {
      logo: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.logo', 'google.logo'] },
        affects: ['apple.logo', 'google.logo', 'shared.icon', 'apple.icon'],
      },
      icon: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.icon', 'google.logo'] },
        affects: ['apple.icon', 'google.logo', 'shared.logo', 'apple.logo'],
      },
      banner: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.banner', 'google.banner'] },
        affects: ['apple.banner', 'google.banner'],
      },
    },
    apple: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'google.logo', 'shared.icon'],
      },
      icon: {
        visible: true,
        affects: ['shared.icon', 'google.logo', 'shared.logo'],
      },
      banner: {
        visible: true,
        affects: ['shared.banner', 'google.banner'],
      },
    },
    google: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'shared.icon', 'apple.logo', 'apple.icon'],
      },
      wideLogo: { visible: true },
      banner: {
        visible: true,
        affects: ['shared.banner', 'apple.banner'],
      },
    },
  },
  transit: {
    shared: {
      logo: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.logo', 'google.logo'] },
        affects: ['apple.logo', 'google.logo', 'shared.icon', 'apple.icon'],
      },
      icon: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.icon', 'google.logo'] },
        affects: ['apple.icon', 'google.logo', 'shared.logo', 'apple.logo'],
      },
    },
    apple: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'google.logo', 'shared.icon'],
      },
      icon: {
        visible: true,
        affects: ['shared.icon', 'google.logo', 'shared.logo'],
      },
    },
    google: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'shared.icon', 'apple.logo', 'apple.icon'],
      },
      wideLogo: { visible: true },
      banner: {
        visible: true,
        affects: ['shared.banner', 'apple.banner'],
      },
    },
  },
  stampCard: {
    shared: {
      logo: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.logo', 'google.logo'] },
        affects: ['apple.logo', 'google.logo', 'shared.icon', 'apple.icon'],
      },
      icon: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.icon', 'google.logo'] },
        affects: ['apple.icon', 'google.logo', 'shared.logo', 'apple.logo'],
      },
      banner: {
        visible: true,
        requiredIf: { unlessAllOf: ['apple.banner', 'google.banner'] },
        affects: ['apple.banner', 'google.banner'],
      },
    },

    apple: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'google.logo', 'shared.icon'],
      },
      icon: {
        visible: true,
        affects: ['shared.icon', 'google.logo', 'shared.logo'],
      },
      banner: {
        visible: true,
        affects: ['shared.banner', 'google.banner'],
      },
    },

    google: {
      logo: {
        visible: true,
        affects: ['shared.logo', 'shared.icon', 'apple.logo', 'apple.icon'],
      },
      wideLogo: { visible: true },
      banner: {
        visible: true,
        affects: ['shared.banner', 'apple.banner'],
      },
    },
  },
} as const;
